import React from 'react';
export var ProgressBar = function (_a) {
    var onClick = _a.onClick, progress = _a.progress;
    return (React.createElement("div", { className: 'str-chat__message-attachment-audio-widget--progress-track', "data-progress": progress, "data-testid": 'audio-progress', onClick: onClick, role: 'progressbar', style: {
            '--str-chat__message-attachment-audio-widget-progress': progress + '%',
        } },
        React.createElement("div", { className: 'str-chat__message-attachment-audio-widget--progress-slider', style: { left: "".concat(progress, "px") } })));
};
